import { useTranslation } from 'react-i18next';
import type { ManualDeclaration } from '../../types/agent';
import { CellText } from './CellLink';

/** A manual write, declared before any of it runs (sculpt-api `start_manual`, PLAN-building-operations.md §3.6):
 *  why no operation covers the change, and the only sheets the agent may write on until the turn ends. It sits
 *  above the batch, like a Change Plan: what is about to happen, then the batch reporting it happening. Everything
 *  written after it can be taken back as a whole with the undo, which the card says. A place the why names is a link
 *  (`CellText`). */
export function ManualCard({ declaration, onShowCell, sheets }: {
  declaration: ManualDeclaration;
  onShowCell?: (sheet: string, cell: string) => void;
  sheets?: readonly string[];
}) {
  const { t } = useTranslation();
  return (
    <div className="animate-pc-in-enter overflow-hidden rounded-lg border border-line-card bg-white" data-testid="manual-card">
      <div className="px-3 py-2">
        <div className="text-[12.5px] font-medium text-ink">{t('manual.title')}</div>
        <div className="mt-0.5 text-[11.5px] text-muted" data-testid="manual-why"><CellText text={declaration.why} sheets={sheets} onSelectRange={onShowCell} /></div>
      </div>
      <div className="flex flex-col gap-0.5 border-t border-line-row px-3 py-1.5 text-[11.5px]">
        <span className="text-ink" data-testid="manual-sheets">{t('manual.sheets', { sheets: declaration.sheets.join(', ') })}</span>
        <span className="text-fainter">{t('manual.undo')}</span>
      </div>
    </div>
  );
}
